import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Key, Copy, Check, ArrowRight, MessageCircle } from 'lucide-react';
export function ActionSteps() {
  const [copied, setCopied] = useState(false);
  const referralCode = 'axgrE5T8';
  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <section className="w-full py-20 px-6 md:px-12 relative z-20" data-id="element-1">
      <div className="max-w-3xl mx-auto flex flex-col items-center gap-16" data-id="element-2">
        {/* Referral Code */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="w-full flex flex-col items-center gap-6" data-id="element-3">
          <div className="flex items-center gap-3 text-gray-300" data-id="element-4">
            <Key className="w-5 h-5 text-gold-500" data-id="element-5" />
            <span className="text-lg font-medium" data-id="element-6">Código de referido:</span>
          </div>

          <div className="relative group" data-id="element-7">
            <div className="absolute -inset-1 bg-gradient-to-r from-gold-600/20 via-gold-500/20 to-gold-600/20 rounded-2xl blur opacity-70 group-hover:opacity-100 transition duration-500" data-id="element-8" />
            <div className="relative flex items-center justify-between bg-carbon-900 border border-gold-500/30 rounded-2xl p-2 pl-8 pr-2 w-[300px] sm:w-[350px]" data-id="element-9">
              <span className="font-mono text-2xl text-gold-200 tracking-wider font-semibold" data-id="element-10">
                {referralCode}
              </span>
              <button onClick={handleCopy} className="flex items-center justify-center w-12 h-12 rounded-xl bg-carbon-800 hover:bg-carbon-700 border border-carbon-600 transition-colors" aria-label="Copiar código" data-id="element-11">
                {copied ? <Check className="w-5 h-5 text-green-400" data-id="element-12" /> : <Copy className="w-5 h-5 text-gold-400" data-id="element-13" />}
              </button>
            </div>
            {copied && <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} className="absolute -bottom-8 left-0 w-full text-center text-sm text-green-400 font-medium" data-id="element-14">
                ¡Código copiado!
              </motion.div>}
          </div>
        </motion.div>

        {/* Main CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="w-full flex flex-col items-center" data-id="element-15">
          <a href="https://vantageapp.onelink.me/qaPD?af_xp=referral&pid=IBSHARE&deep_link_value=mt4id-192769%7Cplatform-copytrading&deep_link_sub1=spid-1272891&af_dp=com.vttech.VantageFX%3A%2F%2F&af_force_deeplink=true" target="_blank" rel="noopener noreferrer" className="group relative w-full sm:w-auto inline-flex items-center justify-center gap-3 px-10 py-5 bg-carbon-900 border border-gold-500/50 rounded-2xl overflow-hidden transition-all hover:scale-[1.02] hover:border-gold-400 shadow-[0_0_30px_rgba(212,175,55,0.1)] hover:shadow-[0_0_40px_rgba(212,175,55,0.25)]" data-id="element-16">
            <div className="absolute inset-0 bg-gradient-to-r from-gold-500/0 via-gold-500/10 to-gold-500/0 translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-1000" data-id="element-17" />
            <span className="relative z-10 font-serif text-xl font-bold text-gold-300 tracking-wide" data-id="element-18">
              AFILIARSE AL COPY
            </span>
            <ArrowRight className="w-6 h-6 text-gold-400 relative z-10 group-hover:translate-x-1 transition-transform" data-id="element-19" />
          </a>
        </motion.div>

        {/* WhatsApp CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="w-full flex flex-col items-center gap-6 pt-12 border-t border-carbon-800" data-id="element-20">
          <p className="text-center text-gray-400 max-w-md leading-relaxed" data-id="element-21">
            Si tenés alguna duda o querés que te ayude a activar el copy,
            comunicate conmigo a mi número personal.
          </p>

          <a href="http://wa.me/+5493364322501" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366]/10 text-[#25D366] hover:bg-[#25D366]/20 border border-[#25D366]/30 rounded-xl font-medium transition-all hover:scale-[1.02]" data-id="element-22">
            <MessageCircle className="w-5 h-5" data-id="element-23" />
            <span data-id="element-24">ESCRIBIRME A WHATSAPP</span>
          </a>
        </motion.div>
      </div>
    </section>;
}